// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".f4715726b47b31a6c3ce7cd912f072b2.js";
};